// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.limit-reached-modal .modal-dialog{max-width:600px}`, "",{"version":3,"sources":["webpack://./client/Applications/DataGrids/Components/Limits/LimitReachedModal.scss"],"names":[],"mappings":"AAAA,mCACI,eAAA","sourcesContent":[".limit-reached-modal .modal-dialog {\n    max-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
